import {CategoryWithStatus} from '@src/dtos/category-with-status.dto';
import {FilterConfig} from '@src/model/filter';
import {CategoriesFilterNames} from '@src/utils/enums';

/** Filter configuration for the PowerDNS categories used in the bronze portal. */
export const bronzeCategoryFiltersConfig: FilterConfig<CategoryWithStatus> = {
    searchBox: {placeholder: 'Search Category', byFields: ['categoryTitle']},
    localStorageKey: 'bronzeCategoryDefaultFilter',
    radioButtons: {
        defaultSelectionIndex: 0,
        options: [
            {label: CategoriesFilterNames.All, filterFn: () => true},
            {label: CategoriesFilterNames.Blocked, filterFn: (category: CategoryWithStatus) => !category.isAllow},
            {label: CategoriesFilterNames.Allowed, filterFn: (category: CategoryWithStatus) => category.isAllow},
        ],
    },
};

